/** Tipos padrão do motorista ocasional (mesma rotina de criação de veículo). */
export const REQUIRED_OCCASIONAL_VEHICLE_TYPES = [
  { label: 'Carro', name: 'Carro' },
  { label: 'Van', name: 'Van' },
  { label: 'Micro Ônibus', name: 'Micro Ônibus' },
  { label: 'Ônibus', name: 'Ônibus' },
];

export const normalizeVehicleTypeName = (name = '') =>
  name
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .trim();

export const buildOccasionalVehicleOption = ({ id, placa, tipo, capacidade, type }) => {
  const typeName = type?.name || tipo;

  return {
    id,
    value: id,
    licensePlate: placa,
    type: type || {
      name: typeName,
    },
    capacity: capacidade,
    label: `${placa} - ${typeName} - ${capacidade} lugares`,
    isOccasional: true,
  };
};
